import { render } from "./InfoCard.vue?vue&type=template&id=316a240a&scoped=true&ts=true"
import script from "./InfoCard.vue?vue&type=script&lang=ts"
export * from "./InfoCard.vue?vue&type=script&lang=ts"

import "./InfoCard.vue?vue&type=style&index=0&id=316a240a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/mlp/mlp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-316a240a"]])

export default __exports__